import { SCHEDULED_INTERVIEW_LIST, INTERVIEW_STATUS_TOGGLE, SCHEDULED_INTERVIEW_COUNT } from '../constant/actionTypes';
import request from '../api/api';

export const getScheduledInterviewData = (data) => {
   return async (dispatch) => {
      try {
         const res = await request({
            url: '/candidate/get/interview_details',
            method: 'POST',
            data: data,
         });
         if (res.status === 1) {
            dispatch({
               type: SCHEDULED_INTERVIEW_LIST,
               payload: res.response ? res.response && res.response.result : [],
            });
            dispatch({
               type: SCHEDULED_INTERVIEW_COUNT,
               payload: res.response ? res.response && res.response.fullcount : 0,
            });
         } else {
            dispatch({
               type: SCHEDULED_INTERVIEW_LIST,
               payload: [],
            });
            dispatch({
               type: SCHEDULED_INTERVIEW_COUNT,
               payload: 0,
            });
         }
      } catch (err) {
         console.error('Error:', err);
         dispatch({
            type: SCHEDULED_INTERVIEW_LIST,
            payload: [],
         });
         dispatch({
            type: SCHEDULED_INTERVIEW_COUNT,
            payload: 0,
         });
      }
   };
};

export const updateInterviewStatus = (data) => {
   return async (dispatch) => {
      try {
         const res = await request({
            url: '/candidate/update/interview_status',
            method: 'POST',
            data: data,
         });
         if (res.status === 1) {
            dispatch({
               type: INTERVIEW_STATUS_TOGGLE,
               payload: false,
            });
            dispatch(getScheduledInterviewData());
         } else {
            dispatch({
               type: INTERVIEW_STATUS_TOGGLE,
               payload: true,
            });
         }
      } catch (err) {
         console.error('Error:', err);
         dispatch({
            type: INTERVIEW_STATUS_TOGGLE,
            payload: true,
         });
      }
   };
};
